import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useDebouncedAction } from "../../../../../helpers/commonFunction";
import { AppState } from "../../../../../stateManager/store";
import { getValue, getComponents } from "../helpers";
import { DefaultPropsAsset } from './asset/DefaultPropsAsset'
import { pushFormActionStack, updateElement, updateElementOnUndoRedo, updateSelectedFormItemId } from "../../../../../stateManager/store/formCreation_v2/actions";
import { myRedoStack, myUndoStack } from "../stack/Stack";
// import "./defaultProps.css"
import I18AutoCompletion from "../../../Assisted/forms/create/properties/I18NAutoComplete";
import CustomAutoComplete from "../../../Assisted/forms/create/properties/customAutoComplete";

export const DefaultProps = (props: any) => {
  const [elementId, setElementId] = useState<string>("")
  const dispatch = useDispatch();
  const { selectedElementId, deviceType } = useSelector((state: AppState) => state.formJson)
  const { components } = getComponents()
  const [idError, setIdError] = useState(false)
  const component = components[selectedElementId] || {};

  const [labelBlur, setLabelBlur] = useState(true);
  const [labelOldValue, setLabelOldValue] = useState<string>(component?.label || "");
  const [labelValue, setLabelValue] = useDebouncedAction(component?.label, 1000);
  const [visibilityOldValue, setVisibilityOldValue] = useState(component?.properties?.config?.visible);
  const [visibilityValue, setVisibilityValue] = useState(component?.properties?.config?.visible);
  const [hideOnElementsOldValue, sethideOnElementsOldValue] = useState<string>(component?.properties?.config?.visibilityCondition);
  const [hideOnElementsValue, setHideOnElementsValue] = useDebouncedAction(component?.properties?.config?.visibilityCondition);

  useEffect(() => {
    setIdError(false)
    setLabelValue(component?.label || "");
    setLabelOldValue(component?.label || "");
    setElementId(getValue(component, `id`.split("."), deviceType));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedElementId])

  useEffect(() => {
    const visibility = getValue(component, `properties.config.visible`.split("."), deviceType);
    const label = component?.label || "";
    setLabelValue(label);
    setLabelOldValue(label);
    setVisibilityValue(visibility);
    setVisibilityOldValue(visibility);
    setHideOnElementsValue(getValue(component, `properties.config.visibilityCondition`.split("."), deviceType));
    sethideOnElementsOldValue(getValue(component, `properties.config.visibilityCondition`.split("."), deviceType));
    // eslint-disable-next-line
  }, [component])

  const handleChange = (path: string, value: any) => {
    let oldValue: any = null;
    switch (path) {
      case "label":
        oldValue = labelOldValue;
        break;
      case "properties.config.visible":
        oldValue = visibilityOldValue;
        break;
      case "properties.config.visibilityCondition":
        oldValue = hideOnElementsOldValue;
        break;
      default:
        break;
    }
    // Undo Redo for default props
    myUndoStack.push({
      id: selectedElementId,
      path,
      value: oldValue,
      label: "",
      properties: {},
      type: "",
      fields: []
    });
    myRedoStack.clear();
    dispatch(
      updateElement({
        id: selectedElementId,
        path,
        value,
      })
    );
    dispatch(pushFormActionStack({
      undo: () => {
        const poppedElement = myUndoStack.pop();
        if (poppedElement) {
          myRedoStack.push({ ...poppedElement, value })
          dispatch(updateElementOnUndoRedo({
            id: poppedElement.id,
            path: poppedElement.path,
            value: poppedElement.value,
            increment: -1
          }))
        }
      },
      redo: () => {
        const poppedElement = myRedoStack.pop();
        if (poppedElement) {
          myUndoStack.push({ ...poppedElement, value: oldValue });
          dispatch(updateElementOnUndoRedo({
            id: poppedElement.id,
            path: poppedElement.path,
            value: poppedElement.value,
            increment: 1
          }))
        }
      }
    }))

    switch (path) {
      case "properties.config.visible":
        setVisibilityOldValue(value);
        break;
      case "label":
        setLabelOldValue(value);
        break;
      case "properties.config.visibilityCondition":
        sethideOnElementsOldValue(value);
        break;
    }
  };

  const handleIdChangeOnBlur = () => {
    if (elementId && selectedElementId !== elementId) {
      let allIds = Object.keys(components)
      let matchedId = allIds.filter(id => id === elementId)
      if (!matchedId.length) {
        // Undo Redo for Id
        myUndoStack.push({
          id: selectedElementId, // old Id
          fields: [],
          label: "",
          properties: {},
          type: "",
          value: elementId // new Id
        });

        myRedoStack.clear();
        dispatch(updateSelectedFormItemId(selectedElementId, elementId));

        dispatch(pushFormActionStack({
          undo: () => {
            const poppedElement = myUndoStack.pop();
            if (poppedElement) {
              myRedoStack.push({ ...poppedElement, id: selectedElementId, value: elementId })
              dispatch(updateSelectedFormItemId(poppedElement.value, poppedElement.id, -1))
            }
          },
          redo: () => {
            const poppedElement = myRedoStack.pop();
            if (poppedElement) {
              myUndoStack.push({ ...poppedElement });
              dispatch(updateSelectedFormItemId(poppedElement.id, poppedElement.value, 1))
            }
          }
        }))
      } else {
        setIdError(true);
      }
    }
  }

  if (component.isAsset) {
    return <DefaultPropsAsset />
  }

  if (!component?.id) {
    return null
  }

  const showElements = getValue(component, `properties.config.visible`.split("."), deviceType);

  return (
    <div key={selectedElementId}>
      <div className="panel-div">
        <label
          htmlFor="Id"
          className="panel-label"
        >
          Id
        </label>
        <div className="col-span-1" style={{ display: "flex", flexDirection: "column" }}>
          <input
            style={{ cursor: !props.isCheckedIn ? "not-allowed" : "auto" }}
            disabled={!props.isCheckedIn}
            type="text"
            id="Id"
            value={elementId}
            className="panel-input"
            placeholder="Enter id"
            onChange={(e: React.ChangeEvent<HTMLInputElement>) => { setElementId(e.target.value); setIdError(false) }}
            onBlur={handleIdChangeOnBlur}
          />
          {idError && <div className="col-span-2 mt-2" style={{ width: "160px" ,display: "flex", alignItems: "center", fontSize: "12px", fontWeight: 500, color: "#F32727" }}>
            <span className="mr-1">{elementId}</span> ID already exists</div>}
        </div>
      </div>
      <Checkbox
        disabled={!props.isCheckedIn}
        key={"visible"} id={"visible"}
        value={visibilityValue}
        label={"Visible"}
        onChange={(path: string, value: boolean) => {
          setVisibilityValue(value);
          handleChange(path, value);
        }} />
      <div className="panel-div">
        <label
          htmlFor="Id"
          className="panel-label"
        >
          {`${!showElements ? "Show" : "Hide"} On`
          }
        </label>
        <input
          style={{ cursor: !props.isCheckedIn ? "not-allowed" : "auto", background: "#FFFFFF" }}
          disabled={!props.isCheckedIn}
          type="text"
          id="Id"
          value={hideOnElementsValue || ""}
          className="panel-input"
          placeholder='eg: bindParam === "value"'
          onChange={e => {
            const value = e.target.value;
            setHideOnElementsValue(value, () => handleChange(`properties.config.visibilityCondition`, value))
          }}
        />
      </div>
      {
        !["Text", "Otp", "VideoKYC"].includes(component.type) && component.type !== "Select" && (
          <div className="panel-div tour_properties_label">
            <label
              htmlFor="Label"
              className="panel-label"
            >
              Label
            </label>
            <div style={{ height: 28, width: 170, backgroundColor: "#ffffff" }}>
              {/* <AutoComplete
                className="key-select-dropdown"
                dropdownClassName="col-span-1  bg-white border border-gray-300 text-gray-900 font-medium rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full  pl-1.5"
                style={{ cursor: !props.isCheckedIn ? "not-allowed" : "auto", fontSize: 12, color: "#292D32", height: "12px", borderRadius: "2px", borderColor: "rgba(125, 132, 146, 0.294)", background: "#FFFFFF", paddingLeft: 1.5 }}
                disabled={!props.isCheckedIn}
                id="label"
                defaultValue={labelValue}
                value={labelValue}
                dropdownMatchSelectWidth={false}
                dropdownMenuStyle={{ maxHeight: "214px", borderRadius: 10, boxShadow: "0px 6px 10px #D7D9E5" }}
                dataSource={autoCompleteData && autoCompleteData.map((data: any) => (
                  <div key={data.key} style={{ display: "flex", flexDirection: "column" }}>
                    <div style={{ color: '#3461A2' }}>{data.key}</div>
                    <div style={{ color: "#393939", paddingBottom: 4 }}>{data.value}</div>
                    <div style={{ borderTop: "1px solid #BEC1C8", width: "100%" }}></div>
                  </div>
                ))}
                onChange={(e: any) => {
                  const regexPattern = /^\$i18n\./
                  if (e.length >= 8) {
                    if (regexPattern.test(e)) {
                      i18nSuggestion(e.slice(6))
                    }
                  } else {
                    setAutoCompleteData([])
                  }
                  setLabelValue(e, () => handleChange(`label`, e))
                }}
                onSelect={(e: any) => {
                  setLabelValue("$i18n." + e, () => handleChange(`label`, "$i18n." + e))
                }}
              /> */}
              {labelBlur ?
                  <div onClick={() => setLabelBlur(false)}>
                    <I18AutoCompletion dataTestId="label"
                      value={labelValue} />
                  </div>
                  :
                  <CustomAutoComplete
                    dataTestId="label"
                    disabled={!props.isCheckedIn}
                    value={labelValue}
                    defaultValue={labelValue}
                    onChange={(val) => {
                      setLabelValue(val, () => handleChange(`label`, val))
                    }}
                    onSelect={(val) => {
                      setLabelValue(val, () => handleChange(`label`, val))
                    }}
                    onBlur={() => setLabelBlur(true)}
                  />
              }
            </div>
          </div>
        )
      }
    </div >
  )
};

interface ICheckbox {
  id: string;
  value: boolean;
  label: string;
  onChange: (path: string, value: boolean) => void
  disabled?: boolean;
  checked?: boolean
}

const Checkbox: React.FC<ICheckbox> = ({ disabled, id, value, label, onChange, checked }) => {
  return (
    <div className="panel-div">
      <div className="panel-label"></div>
      <div className="flex items-center" style={{width:170}}>
        <div
          id={id}
          style={{
            display: "block", width: "15px", height: "15px", border: "1px solid rgba(125, 132, 146, 0.294)", cursor: "pointer",
            boxSizing: "border-box", background: value ? "#0466C8" : "#FFFFFF", borderRadius: "4px", pointerEvents: disabled ? "none" : "initial"
          }}
          className="focus:outline-none"
          onClick={() => { onChange(`properties.config.visible`, !value) }}
        >
          {value && (
            <div style={{ marginTop: "-2px", marginLeft: "-1px", display: "flex", alignItems: "center", width: "inherit", height: "inherit" }}>
              <svg viewBox="0 0 14 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M5 7.62163L6.62162 9.24325L9.86487 6.00001" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
              </svg></div>
          )}
        </div>
        <label
          onClick={() => { onChange(`properties.config.visible`, !value) }}
          htmlFor={id}
          className="checkbox-label"
          style={{fontWeight:value?700:600}}
        >
          {label}
        </label>
      </div>
    </div>
  );
};
